import { AuthError, type AuthErrorCode } from '@emazy/shared-types';

const friendlyMessages: Record<AuthErrorCode, string> = {
  'invalid-credentials': 'Email or password is incorrect. Please try again.',
  'email-not-verified': 'Verify your email before signing in.',
  'email-already-exists': 'An account already uses this email. Try signing in instead.',
  'invalid-verification-code': 'That code is not valid. Check all six digits and try again.',
  'expired-verification-code': 'That code has expired. Request a new one and try again.',
  'weak-password': 'Choose a password that meets every requirement.',
  'password-reset-required': 'Reset your password before signing in.',
  'too-many-attempts': 'Too many attempts. Wait a moment before trying again.',
  'network-error': 'We could not reach the authentication service. Please try again.',
  'session-expired': 'Your session expired. Sign in again to continue.',
  unauthorized: 'This account does not have permission to access that area.',
  'unsupported-auth-challenge':
    'This account requires a sign-in step that Emazy does not support yet. Contact support.',
  unknown: 'We could not complete that request. Please try again.',
};

export function normalizeAuthError(error: unknown) {
  if (error instanceof AuthError) return error;
  if (import.meta.env.DEV) console.error('Unexpected authentication error', error);
  return new AuthError({ code: 'unknown', message: friendlyMessages.unknown, cause: error });
}

export function getAuthErrorMessage(error: unknown) {
  return friendlyMessages[normalizeAuthError(error).code];
}
